import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function get_run_results(run_id) {
    /**
     * Fetches the full results payload of a completed optimization run.
     *
     * Returns the solver's ProblemResponse — i.e. { problemResult, resultSummary } —
     * the same shape the solve endpoint used to return synchronously. Only call this
     * once /run_status reports the run as "succeeded".
     *
     * @param {string} run_id - The ID of the run to load results for.
     * @returns {Object} { problemResult, resultSummary }
     */
    if (!run_id) {
        throw new Error('Run ID is required for get_run_results');
    }

    const retJson = await generic_backend_request_post({ run_id }, '/run_results_by_run_id');
    return retJson;
}

export default get_run_results;
